import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";


export const oauthBeam = createBeam(bifrost, "/oauth");
